<template lang="pug">
  .mx-auto.max-w-screen-lg.text-center(class="w-10/12")
    .font-display.text-lightCyan.italic.tracking-widest(class="text-lg md:text-3xl") MISSON : 2
    h2.misson-title(ref="title")
      img.mx-auto(class="hidden ls:block" alt="オリジナルマグロボを報告せよ！" src="images/common/misson-2.png" srcset="images/common/misson-2@2x.png 2x")
      img.mx-auto(class="ls:hidden" alt="オリジナルマグロボを報告せよ！" src="images/common/misson-2-sp.png" srcset="images/common/misson-2-sp@2x.png 2x, images/common/misson-2-sp@3x.png 3x")
    .max-w-2xl.mx-auto
      p(class="text-xs md:text-base") 
        span(:class="{hidden: !isTouchDevice}") 上記のMAGROBOカードを長押しで画像を保存して、
        span(:class="{hidden: isTouchDevice}") 上記のMAGROBOカード画像を保存して、
        br
        span
          span.text-bolt 「#マグロボからの挑戦」
          | の
        span.inline-block ハッシュタグをつけてツイートしてくれ！
      p.mt-8.text-xs(:class="{hidden: isTouchDevice}") ※パソコンでは右クリックで「名前を付けて画像を保存」で画像を保存してください。

</template>

<script>
export default {
  name: "Home",
  mounted() {
    this.$nextTick(() => {
      this.$refs.title.classList.add("animation");
    });
  }
};
</script>
